// libraries and utilities
import { put, call, takeEvery} from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPost, BASE_URL, retrieveToken } from "../../store/api";
import { JenisDokumenCreateResponse } from "./types";

import * as jenisDokumenActions from "./jenisDokumen.actions";
import { showModal } from "../modal/modal.actions";

export function* createJenisDokumen(
  action: ReturnType<typeof jenisDokumenActions.createJenisDokumenAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'jenis-dokumen';
    const result: Response = yield call(apiPost, url, token, action.payload);

    if (result.status === 201) {
      const parsed: JenisDokumenCreateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(jenisDokumenActions.createJenisDokumenAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(jenisDokumenActions.createJenisDokumenAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Terjadi kesalahan pada server', 'Silahkan coba kembali dalam beberapa saat'));
    yield put(jenisDokumenActions.createJenisDokumenAsync.failure(parsed));
  }
}

export default function* jenisDokumenSagaCreateJenisDokumen() {
  yield takeEvery(jenisDokumenActions.createJenisDokumenAsync.request, createJenisDokumen);
}
